// skipcq: JS-W1028
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

import BeerProfileAggregatedRatingsCard from './BeerProfileAggregatedRatingsCard';
import { BeerProfileMetadataCard } from './BeerProfileDetailsPanel';
import BeerProfileGlassIllustration from './BeerProfileGlassIllustration';

function PintPortfolioBeerProfileContent({
  glassPath,
  styleName,
  styleType,
  abv,
  descriptionText,
  listingLocationLabels = [],
  ratings,
  tags,
  tagLabelMap,
  onEditOpen,
}) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
        gap: 3,
        alignItems: 'start',
      }}
    >
      <Box>
        <BeerProfileGlassIllustration glassPath={glassPath} />
        <Box sx={{ mt: 3 }}>
          <BeerProfileMetadataCard
            styleName={styleName}
            styleType={styleType}
            abv={abv}
            descriptionText={descriptionText}
            listingLocationLabels={listingLocationLabels}
            onEditOpen={onEditOpen}
          />
        </Box>
      </Box>
      <BeerProfileAggregatedRatingsCard
        ratings={ratings}
        tags={tags}
        tagLabelMap={tagLabelMap}
      />
    </Box>
  );
}

PintPortfolioBeerProfileContent.propTypes = {
  glassPath: PropTypes.string.isRequired,
  styleName: PropTypes.string.isRequired,
  styleType: PropTypes.string.isRequired,
  abv: PropTypes.number,
  descriptionText: PropTypes.string,
  listingLocationLabels: PropTypes.arrayOf(PropTypes.string),
  ratings: PropTypes.shape({
    overall: PropTypes.number,
    appearance: PropTypes.number,
    aroma: PropTypes.number,
    flavor: PropTypes.number,
    mouthfeel: PropTypes.number,
  }),
  tags: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        tag: PropTypes.string,
        count: PropTypes.number,
      }),
    ),
  ),
  tagLabelMap: PropTypes.objectOf(PropTypes.string).isRequired,
  onEditOpen: PropTypes.func.isRequired,
};

export default PintPortfolioBeerProfileContent;
